module.exports = __webpack_public_path__ + "img/other_appearance.81067ba6.svg";